if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        document.documentElement.classList.remove('overflow-hidden');
      }

      show(opener) {
        super.show(opener);
        document.documentElement.classList.add('overflow-hidden');
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]`).forEach((element, index) => {
          if (index === 0) {
            element.classList.add('active');
            element.scrollIntoView();
          } else {
            element.classList.remove('active');
          }
        });

        const first = this.querySelector('[data-media-id]');
        const container = this.querySelector('[role="document"]');
        if (first && container) {
          container.scrollLeft = (first.width - container.clientWidth) / 2;
        }

        const activeMediaTemplate = first?.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          first?.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent?.querySelector('.js-youtube')
        ) {
          first.loadContent();
        }
      }

    }
  );
}
